module.exports = __webpack_public_path__ + "img/slide_4.2bbcf92e.jpg";